module.exports = __webpack_public_path__ + "../resources/img/bg_grid1_03.600003ce.png";